import { FunctionComponent, useRef, useState, useLayoutEffect } from 'react'
import { Tooltip, rucksack } from '@black-bear-energy/rucksack'
import { SxProps, Theme, Typography, TypographyVariant } from '@mui/material'
import { getSearchFormattedText } from '../helpers/getSearchFormattedText'

export const TextWithTooltip: FunctionComponent<TextWithTooltipProps> = ({
  text,
  variant = 'body1',
  maxLineCount = 2,
  searchString,
  sx,
}) => {
  const [isTextTruncated, setIsTextTruncated] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)
  const tooltipText = isTextTruncated ? text : ''
  const variantSX = rucksack.font[variant]

  const checkTruncation = () => {
    if (textRef.current) {
      const element = textRef.current
      const isTruncated =
        element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth
      setIsTextTruncated(isTruncated)
    }
  }

  useLayoutEffect(() => {
    checkTruncation()
  }, [text])

  const formattedText = getSearchFormattedText(text, searchString)

  return (
    <Tooltip title={tooltipText}>
      <Typography
        ref={textRef}
        variant={variant}
        onMouseEnter={checkTruncation}
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: maxLineCount,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          font: variantSX,
          ...sx,
        }}
      >
        {formattedText}
      </Typography>
    </Tooltip>
  )
}

interface TextWithTooltipProps {
  text: string
  variant?: TypographyVariant
  maxLineCount?: number
  searchString?: string
  sx?: SxProps<Theme>
}
